import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sample" }
const _hoisted_2 = { class: "sample__menu" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "sample__menu-title" }, "Style guide", -1)
const _hoisted_4 = { class: "sample__menu-list" }
const _hoisted_5 = { class: "sample__menu-item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Style guide")
const _hoisted_7 = { class: "sample__menu-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Colors")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "sample__menu-title" }, "Components", -1)
const _hoisted_10 = { class: "sample__menu-list" }
const _hoisted_11 = { class: "sample__menu-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Button")
const _hoisted_13 = { class: "sample__menu-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Icon")
const _hoisted_15 = { class: "sample__menu-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Table")
const _hoisted_17 = { class: "sample__menu-item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("InputText")
const _hoisted_19 = { class: "sample__menu-item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("InputTextArea")
const _hoisted_21 = { class: "sample__menu-item" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("InputCheckbox")
const _hoisted_23 = { class: "sample__menu-item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("InputSwitch")
const _hoisted_25 = { class: "sample__menu-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("InputSelect")
const _hoisted_27 = { class: "sample__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("ul", _hoisted_4, [
        _createVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleStyleGuide'}
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleColors'}
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_9,
      _createVNode("ul", _hoisted_10, [
        _createVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleButton'}
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_13, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleIcon'}
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_15, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleTable'}
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleInputText'}
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_19, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleInputTextArea'}
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_21, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleInputCheckbox'}
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_23, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleInputSwitch'}
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_25, [
          _createVNode(_component_router_link, {
            class: "sample__menu-link",
            to: {name: 'SampleInputSelect'}
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_router_view)
    ])
  ]))
}